module.exports = __webpack_public_path__ + "img/scale_down.b0f08509.svg";